import { cx } from 'class-variance-authority';

export const ContactInfoLine = ({
  children,
  lastElement = false,
}: {
  children: React.ReactNode;
  lastElement?: boolean;
}) => (
  <li
    className={cx([
      'flex',
      'gap-4',
      'items-center',
      'sm:justify-between',
      'py-2',
      'border-b-primary-100',
      'border-b-2',
      'last:border-b-0',
    ])}
  >
    {children}
  </li>
);
